module.exports = "/images/information.svg";